import React from "react";
import { Link, NavLink } from "react-router-dom";
import { FaGithub } from "react-icons/fa";
import {
  FiHome,
  FiFolder,
  FiUser,
  FiMail,
  FiFileText,
  FiShield,
  FiMenu,
  FiX,
} from "react-icons/fi";
import projects from "../data/projects/projectsData"; // Import projects data
import { useNav } from "../context/NavContext";
import ThemeToggle from "./ThemeToggle";
import styles from "../style/navigation.module.css";

const Navbar = () => {
  const {
    navOpen,
    projectsOpen,
    setProjectsOpen,
    closeAllMenus,
    toggleNav,
  } = useNav();

  return (
    <>
      {navOpen && (
        <button
          type="button"
          className={styles.navOverlay}
          aria-label="Close navigation"
          onClick={closeAllMenus}
        />
      )}

      <nav className="navbar navbar-light text-light py-4 py-md-3 px-md-3">
        <div className="container page-shell d-flex justify-content-between align-items-center">
          <div className={styles.navLeft}>
            {/* Side-drawer toggle (all sizes) */}
            <button
              type="button"
              className={styles.navMobileToggle}
              aria-label={navOpen ? "Close menu" : "Open menu"}
              aria-controls="nav-drawer"
              aria-expanded={navOpen}
              onClick={toggleNav}
            >
              {navOpen ? <FiX aria-hidden="true" /> : <FiMenu aria-hidden="true" />}
            </button>

            <Link className={`nav-link ${styles.navBrand}`} to="/" onClick={closeAllMenus}>
              Avida2C
            </Link>
          </div>

          <div className={styles.navActions}>
            <ThemeToggle />
            <a
              className={`nav-link ${styles.navGithub} d-inline-flex`}
              href="https://github.com/Avida2C"
              target="_blank"
              rel="noreferrer"
              aria-label="GitHub"
            >
              <FaGithub
                style={{ width: "2.5rem", height: "2.5rem" }}
                aria-hidden="true"
              />
            </a>
          </div>
        </div>
      </nav>

      {/* Side drawer navigation (no dropdowns) */}
      <aside
        id="nav-drawer"
        className={`${styles.navDrawer} ${navOpen ? "is-open" : ""}`}
      >
        <div className={styles.navDrawerHead}>
          <button
            type="button"
            className={styles.navDrawerClose}
            aria-label="Close menu"
            onClick={closeAllMenus}
          >
            ✕
          </button>
        </div>

        <nav className={styles.navDrawerBody} aria-label="Site navigation">
          <NavLink
            end
            className={({ isActive }) =>
              `${styles.navDrawerLink}${isActive ? " active" : ""}`
            }
            to="/"
            onClick={closeAllMenus}
          >
            <FiHome className={styles.navDrawerLinkIcon} aria-hidden="true" />
            Home
          </NavLink>

          <button
            type="button"
            className={`${styles.navDrawerLink} ${styles.navDrawerAccordion}`}
            aria-expanded={projectsOpen}
            onClick={() => setProjectsOpen((v) => !v)}
          >
            <span className={styles.navDrawerLinkLabel}>
              <FiFolder className={styles.navDrawerLinkIcon} aria-hidden="true" />
              Projects
            </span>
            <span className={styles.navDrawerAccordionIcon}>▾</span>
          </button>
          <div
            className={`${styles.navDrawerProjects} ${
              projectsOpen ? "is-open" : ""
            }`}
          >
            <Link
              className={`${styles.navDrawerSublink} ${styles.navDrawerSublinkAll}`}
              to="/projects"
              onClick={closeAllMenus}
            >
              Browse all projects
            </Link>
            {projects.map((project) => (
              <Link
                key={project.link}
                className={styles.navDrawerSublink}
                to={project.link}
                onClick={closeAllMenus}
              >
                {project.title}
              </Link>
            ))}
          </div>

          <NavLink
            className={({ isActive }) =>
              `${styles.navDrawerLink}${isActive ? " active" : ""}`
            }
            to="/about"
            onClick={closeAllMenus}
          >
            <FiUser className={styles.navDrawerLinkIcon} aria-hidden="true" />
            About
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              `${styles.navDrawerLink}${isActive ? " active" : ""}`
            }
            to="/contact"
            onClick={closeAllMenus}
          >
            <FiMail className={styles.navDrawerLinkIcon} aria-hidden="true" />
            Contact
          </NavLink>

          <NavLink
            className={({ isActive }) =>
              `${styles.navDrawerLink} ${styles.navDrawerLinkLegal}${isActive ? " active" : ""}`
            }
            to="/terms"
            onClick={closeAllMenus}
          >
            <FiFileText className={styles.navDrawerLinkIcon} aria-hidden="true" />
            Terms of Service
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              `${styles.navDrawerLink} ${styles.navDrawerLinkLegal}${isActive ? " active" : ""}`
            }
            to="/privacy"
            onClick={closeAllMenus}
          >
            <FiShield className={styles.navDrawerLinkIcon} aria-hidden="true" />
            Privacy Policy
          </NavLink>
        </nav>

        <div className={styles.navDrawerFoot}>
          <div className={styles.navDrawerActions}>
            <ThemeToggle />
            <a
              className={`nav-link ${styles.navGithub} d-inline-flex`}
              href="https://github.com/Avida2C"
              target="_blank"
              rel="noreferrer"
              aria-label="GitHub"
              onClick={closeAllMenus}
            >
              <FaGithub
                style={{ width: "2.5rem", height: "2.5rem" }}
                aria-hidden="true"
              />
            </a>
          </div>
          <div className={styles.navDrawerDivider} role="presentation" />
          <p className={styles.navDrawerCopyright}>
            © 2026 Avida2C. All Rights Reserved. Designed &amp; Built By Avida2C
            | Powered By Creativity
          </p>
        </div>
      </aside>
    </>
  );
};

export default Navbar;
